<template>
  <div class=" overflow-hidden max-w-3xl mx-auto my-12  sm:rounded-lg">
    <div class="md:flex md:items-center md:justify-between">
      <div class="min-w-0 flex-1">
        <h2
          class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight text-center my-4"
        >
          CartHike
        </h2>
      </div>
    </div>
    <div v-if="!isLoading && checkout">
      <div class="bg-white shadow">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
          <h3
            class="text-lg leading-6 font-medium text-gray-900 flex justify-between"
          >
            Order details
            <SendMessageDropdown
              :checkout="checkout"
              :isPublicDropDown="true"
            />
          </h3>
        </div>
        <div class="px-4 py-5 sm:p-0">
          <dl>
            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
              <dt class="text-sm leading-5 font-medium text-gray-500">
                Customer
              </dt>
              <dd
                class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
              >
                {{ checkout.customer.firstName }}
                {{ checkout.customer.lastName }}
              </dd>
            </div>
            <div
              class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
            >
              <dt class="text-sm leading-5 font-medium text-gray-500">
                Date
              </dt>
              <dd
                class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
              >
                {{ checkout.createdAt | dateFilter }}
              </dd>
            </div>
            <div
              class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
            >
              <dt class="text-sm leading-5 font-medium text-gray-500">
                Recovery status
              </dt>
              <dd
                class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
              >
                <span
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full "
                  :class="{
                    'bg-red-100 text-red-800': !checkout.isRecovered,
                    'bg-green-100 text-green-800': checkout.isRecovered
                  }"
                >
                  {{ checkout.isRecovered ? "recovered" : "Not recovered" }}
                </span>
              </dd>
            </div>
            <div
              class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
            >
              <dt class="text-sm leading-5 font-medium text-gray-500">
                Message status
              </dt>
              <dd
                class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
              >
                <span
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full "
                  :class="{
                    'bg-red-100 text-red-800': !checkout.isMessageSent,
                    'bg-green-100 text-green-800': checkout.isMessageSent
                  }"
                >
                  {{ checkout.isMessageSent ? "Sent" : "Not sent" }}
                </span>
              </dd>
            </div>
            <div
              class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
            >
              <dt class="text-sm leading-5 font-medium text-gray-500">
                Checkout id
              </dt>
              <dd
                class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
              >
                {{ checkout.checkoutId }}
              </dd>
            </div>
            <div
              class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
            >
              <dt class="text-sm leading-5 font-medium text-gray-500">
                Total amount
              </dt>
              <dd
                class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
              >
                {{ checkout.currency }} {{ checkout.totalPrice }}
              </dd>
            </div>
          </dl>
        </div>
      </div>
      <div class="bg-white shadow sm:rounded-lg mt-4">
        <div class="px-4 py-5 sm:p-6">
          <h3 class="text-base font-semibold leading-6 text-gray-900">
            To view all abandoned checkouts and send messages
          </h3>
          <div class="mt-5">
            <button
              type="button"
              class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
              @click="gotoApp"
            >
              Goto Carthike app
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center" v-else>Loading...</div>
  </div>
</template>

<script>
import SendMessageDropdown from "../components/Common/SendMessageDropdown";
import { format } from "date-fns";

export default {
  name: "Checkout",
  components: {
    SendMessageDropdown
  },
  data() {
    return {
      checkout: { customer: {}, createdAt: Date.now() },
      isLoading: false
    };
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  async created() {
    this.isLoading = true;
    const checkoutId = this.$route.params.checkoutId;
    // await this.loadTemplates();
    const response = await this.$store.dispatch("getPublicCheckout", {
      checkoutId
    });

    this.checkout = response.checkout;

    this.isLoading = false;
  },
  methods: {
    gotoApp() {
      const store = this.$store.getters.getStore;
      window.open(
        `https://${store.shopOrigin}/admin/apps/${process.env.VUE_APP_SHOPIFY_API_KEY}`
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
